/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable function-paren-newline */
/* eslint-disable max-len */
/* eslint-disable no-var */
import * as Sentry from '@sentry/react';
import AWS from 'aws-sdk';
import Auth from '../utils/Auth';

export const hostName = window.location.hostname.split(':')[0];
export const isLocal = hostName.indexOf('local') === 0 || process.env.REACT_APP_BACKEND_HOST !== undefined;
export const installationId = localStorage.getItem('portalBackendId') ? localStorage.getItem('portalBackendId') : 'us';
var backendBaseUrl = `https://backend.${window.location.hostname}/api`;
export const reportsUrl = `https://reports.${installationId}.${process.env.REACT_APP_ENVIRON_URI?process.env.REACT_APP_ENVIRON_URI:''}aerosimple.com`;
export const instData = {};
const apiBaseUrl = `https://api.${installationId}.${process.env.REACT_APP_ENVIRON_URI?process.env.REACT_APP_ENVIRON_URI:''}aerosimple.com/api`;

export const fetchInstData = async (backendId) => {
  if (!instData[backendId]) {
    // get inst details
    Auth.updateAwsAuth();
    const docClient = new AWS.DynamoDB.DocumentClient();
    const params = {
      TableName: `${process.env.REACT_APP_PREFIX}installation`,
      Key: { id: backendId }
    };
    await docClient.get(params).promise().then((resp) => {
      instData[backendId] = resp?.Item || {};
    });
  }
};

// call this function after login success
export const fetchBackendUrl = () => new Promise<void>((resolve, reject) => {
  try {
      fetch(`${process.env.REACT_APP_GLOBAL_API}/user/airports/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then(response => response.json())
        .then((data) => {
          localStorage.setItem('portal_airports_access', JSON.stringify(data?.airports?.length));
          if (data?.airports?.length === 1) {
            localStorage.setItem('portalBackendApi', data.airports[0].backend_url);
            localStorage.setItem('portalBackendId', data.airports[0].backend_id);
            resolve();
          } else if (data?.airports?.length > 1) {
            let currentAirport = data.airports.filter(airport => airport.current_selected === true);
            localStorage.setItem('portalBackendApi', currentAirport[0].backend_url);
            localStorage.setItem('portalBackendId', currentAirport[0].backend_id);
            resolve();
          } else {
            resolve();
          }
        })
        .catch((error) => {
          const email = localStorage.getItem('userEmail') || '';
          const domain = email?.split('@')[1] || '';
          const scope = Sentry.getCurrentScope();
          scope.setTag('user.email_domain', domain);
          scope.setTag('user.email', email);
          Sentry.captureException(error);
        });
      } catch (error) {
        const email = localStorage.getItem('userEmail') || '';
        const domain = email?.split('@')[1] || '';
        const scope = Sentry.getCurrentScope();
        scope.setTag('user.email_domain', domain);
        scope.setTag('user.email', email);
        Sentry.captureException(error);
        return reject(error);
      }
  });

export const getReportsBaseUrl = () => (process.env.REACT_APP_REPORTS_URL ? process.env.REACT_APP_REPORTS_URL : getBackendBaseUrl() ? getBackendBaseUrl().replace('backend', 'reports').replace('/api', '') : reportsUrl);

export const getBackendId = () => (isLocal ? 'local' : localStorage.getItem('portalBackendId'));

export const getBackendBaseUrl = () => (
    localStorage.getItem('backendBaseUrl')
  || (isLocal
      ? process.env.REACT_APP_BACKEND_HOST
      :localStorage.getItem('portalBackendApi')
      ?localStorage.getItem('portalBackendApi')
      :backendBaseUrl
   )
  );

export const getApiBaseUrl = () => (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : getBackendBaseUrl() ? getBackendBaseUrl().replace('backend', 'api') : apiBaseUrl);
